import Col from 'react-bootstrap/Col';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import { FormControlType } from '../../../components';
import * as formik from 'formik';
import * as yup from 'yup';

import '../profile.scss';

export default function ProfileUser({ user }) {


    const userSchema = yup.object().shape({
        firstName: yup.string().required('First name is required'),
        lastName: yup.string().required('Last name is required'),
        email: yup.string().matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$/i, 'Invalid email format').required('Email address is required'),
    });

    const initialUserValues = {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
    }

    const { Formik } = formik;

    return (
        <>
            <h4>User Profile</h4>
            <Formik
                validationSchema={userSchema}
                initialValues={initialUserValues}
                enableReinitialize={true} // Reinitialize form when initialValues change
            >
                {({ values }) => (
                    <Form
                        className='app-form-group'
                        noValidate
                    >
                        <Form.Group as={Col} size='sm'>
                            <FloatingLabel
                                label='First name'
                                className='mb-3'
                            >
                                <Form.Control
                                    type={FormControlType.TEXT}
                                    name='firstName'
                                    placeholder='First name'
                                    value={values.firstName}
                                    disabled={true}
                                />
                            </FloatingLabel>
                        </Form.Group>

                        <Form.Group as={Col} size='sm'>
                            <FloatingLabel
                                label='Last name'
                                className='mb-3'
                            >
                                <Form.Control
                                    type={FormControlType.TEXT}
                                    name='lastName'
                                    placeholder='Last name'
                                    value={values.lastName}
                                    disabled={true}
                                />
                            </FloatingLabel>
                        </Form.Group>

                        <Form.Group as={Col} size='sm'>
                            <FloatingLabel
                                label='Email address'
                                className='mb-3'
                            >
                                <Form.Control
                                    type={FormControlType.EMAIL}
                                    name='email'
                                    placeholder='name@example.com'
                                    value={values.email}
                                    disabled={true}
                                />
                            </FloatingLabel>
                        </Form.Group>
                    </Form>
                )}
            </Formik>
        </>
    );
}